import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const roCounties = [
  {
    countyCode: "AB",
    countyName: "Alba",
  },
  {
    countyCode: "AR",
    countyName: "Arad",
  },
  {
    countyCode: "AG",
    countyName: "Argeș",
  },
  {
    countyCode: "BC",
    countyName: "Bacău",
  },
  {
    countyCode: "BH",
    countyName: "Bihor",
  },
  {
    countyCode: "BN",
    countyName: "Bistrița-Năsăud",
  },
  {
    countyCode: "BT",
    countyName: "Botoșani",
  },
  {
    countyCode: "BV",
    countyName: "Brașov",
  },
  {
    countyCode: "BR",
    countyName: "Brăila",
  },
  {
    countyCode: "B",
    countyName: "București",
  },
  {
    countyCode: "BZ",
    countyName: "Buzău",
  },
  {
    countyCode: "CS",
    countyName: "Caraș-Severin",
  },
  {
    countyCode: "CL",
    countyName: "Călărași",
  },
  {
    countyCode: "CJ",
    countyName: "Cluj",
  },
  {
    countyCode: "CT",
    countyName: "Constanța",
  },
  {
    countyCode: "CV",
    countyName: "Covasna",
  },
  {
    countyCode: "DB",
    countyName: "Dâmbovița",
  },
  {
    countyCode: "DJ",
    countyName: "Dolj",
  },
  {
    countyCode: "GL",
    countyName: "Galați",
  },
  {
    countyCode: "GR",
    countyName: "Giurgiu",
  },
  {
    countyCode: "GJ",
    countyName: "Gorj",
  },
  {
    countyCode: "HR",
    countyName: "Harghita",
  },
  {
    countyCode: "HD",
    countyName: "Hunedoara",
  },
  {
    countyCode: "IL",
    countyName: "Ialomița",
  },
  {
    countyCode: "IS",
    countyName: "Iași",
  },
  {
    countyCode: "IF",
    countyName: "Ilfov",
  },
  {
    countyCode: "MM",
    countyName: "Maramureș",
  },
  {
    countyCode: "MH",
    countyName: "Mehedinți",
  },
  {
    countyCode: "MS",
    countyName: "Mureș",
  },
  {
    countyCode: "NT",
    countyName: "Neamț",
  },
  {
    countyCode: "OT",
    countyName: "Olt",
  },
  {
    countyCode: "PH",
    countyName: "Prahova",
  },
  {
    countyCode: "SM",
    countyName: "Satu Mare",
  },
  {
    countyCode: "SJ",
    countyName: "Sălaj",
  },
  {
    countyCode: "SB",
    countyName: "Sibiu",
  },
  {
    countyCode: "SV",
    countyName: "Suceava",
  },
  {
    countyCode: "TR",
    countyName: "Teleorman",
  },
  {
    countyCode: "TM",
    countyName: "Timiș",
  },
  {
    countyCode: "TL",
    countyName: "Tulcea",
  },
  {
    countyCode: "VS",
    countyName: "Vaslui",
  },
  {
    countyCode: "VL",
    countyName: "Vâlcea",
  },
  {
    countyCode: "VN",
    countyName: "Vrancea",
  },
];
